module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"generate":"Generate and Download","description":"You can also remove components you don\u0027t need from your custom CSS file. What should be included?\\n"},"ja":{"generate":"生成 & ダウンロード","description":"カスタム CSS ファイルに含めるコンポーネントを選択してください。 不要なコンポーネントは除外することができます。\\n"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/TRGenerator.vue
// module id = T2O3
// module chunks = 1